import { LocationPromiseClient } from "protorepo-dev/generated/node/location_settings/location_grpc_web_pb";
import AuthorizedGrpcClient from "./AuthorizedClient";

export { default as LocationApi } from "protorepo-dev/generated/node/location_settings/location_pb";

export const client = new AuthorizedGrpcClient(LocationPromiseClient).client;
